import * as React from 'react';
import * as styles from './styles';
import * as typestyle from 'typestyle';

/**
 * https://app.frontify.com/d/zYF6HCW0aIp5/ui-library#/atoms/links
 */
export namespace AnchorStyles {
  /** Since we support non HREF anchors we do this as well explicitly */
  const nonHrefAnchor = {
    cursor: 'pointer',
    textDecoration: 'underline',
    background: 'transparent',
    border: 'none',
    padding: '0px',
    fontFamily: styles.fontFamily.arial,
    fontSize: styles.fontSizes.paragraph
  }

  export const rootClassName = typestyle.style(
    nonHrefAnchor,
    {
      color: styles.colors.warmGrey4,
      $nest: {
        '&:hover': {
          color: styles.colors.red,
        },
        '&:focus': {
          color: styles.colors.red,
          outline: 'thin dotted',
          outlineColor: styles.colors.red
        }
      }
    }
  );

  export const rootActionClassName = typestyle.style(
    nonHrefAnchor,
    {
      cursor: 'pointer',
      color: styles.colors.red,
      $nest: {
        '&:hover': {
          color: styles.colors.red,
        },
        '&:focus': {
          color: styles.colors.red,
          outline: 'thin dotted',
          outlineColor: styles.colors.red
        }
      }
    }
  );

  export const rootFooterClassName = typestyle.style(
    nonHrefAnchor,
    {
      fontSize: '13px',
      fontFamily: styles.fontFamily.auspost,
      textDecoration: 'none',

      color: styles.colors.white,
      $nest: {
        '&:hover': {
          textDecoration: 'underline',
        },
        '&:focus': {
          outline: 'thin dotted',
          outlineColor: styles.colors.white,
          textDecoration: 'underline',
        },
      }
    }
  );

  export const rootHeaderClassName = typestyle.style(
    nonHrefAnchor,
    {
      cursor: 'pointer',
      color: styles.colors.red,
      textDecoration: 'none',
      padding: "10px",
      $nest: {
        '&:hover': {
          color: styles.colors.red,
        },
        '&:focus': {
          color: styles.colors.red,
          outline: 'thin dotted',
          outlineColor: styles.colors.red
        },
        '@media screen and (max-width: 768px)': {
          padding: "0 10px 10px 10px"
        }
      }
    }
  );
}

export interface AnchorProps {
  id?: string;
  href?: string;
  target?: "_blank";
  children?: React.ReactNode;
  download?: boolean;
  onClick?: (event?) => any;
  onKeyDown?: (event) => any;
  onKeyUp?: (event) => any;
  onKeyPress?: (event) => any;
  tabIndex?: number;
}

export const Anchor = (props: AnchorProps) => {
  return (
    <a className={AnchorStyles.rootClassName}
      id={props.id}
      href={props.href}
      target={props.target}
      onClick={props.onClick}
      onKeyDown={props.onKeyDown}
      onKeyUp={props.onKeyUp}
      onKeyPress={props.onKeyPress}
      tabIndex={props.tabIndex}
    >
      {props.children}
    </a>
  );
}

/**
 * Like anchor but in `Call to Action` styling
 */
export const ActionAnchor = (props: AnchorProps) => {
  return (
    <a className={AnchorStyles.rootActionClassName}
      id={props.id}
      href={props.href}
      target={props.target}
      onClick={props.onClick}
      onKeyDown={props.onKeyDown}
      onKeyUp={props.onKeyUp}
      onKeyPress={props.onKeyPress}
      download={props.download}
      tabIndex={props.tabIndex}
    >
      {props.children}
    </a>
  );
}

/**
 * For use in footers.
 * Origin: https://auspost.com.au/mypost
 * Has small text size, no underline until hover etc.
 */
export const FooterAnchor = (props: AnchorProps) => {
  return (
    <a className={AnchorStyles.rootFooterClassName}
      id={props.id}
      href={props.href}
      target={props.target}
      onClick={props.onClick}
      onKeyDown={props.onKeyDown}
      onKeyUp={props.onKeyUp}
      onKeyPress={props.onKeyPress}
      download={props.download}
      tabIndex={props.tabIndex}
    >
      {props.children}
    </a>
  );
}

/**
 * For use in header.
 * Origin: https://auspost.com.au/mypost
 * No underline on text
 */
export const HeaderAnchor = (props: AnchorProps) => {
  return (
    <a className={AnchorStyles.rootHeaderClassName}
      id={props.id}
      href={props.href}
      target={props.target}
      onClick={props.onClick}
      onKeyDown={props.onKeyDown}
      onKeyUp={props.onKeyUp}
      onKeyPress={props.onKeyPress}
      download={props.download}
      tabIndex={props.tabIndex}
    >
      {props.children}
    </a>
  );
}
